module.exports = __webpack_public_path__ + "img/fiche-lien.dc51188e.png";